module.exports = __webpack_public_path__ + "media/images/main_visual@3x-8288627f74422b21a925e669f25fe497.png";